import React from 'react';

import { cn } from '@/lib/utils';

export interface PageContainerProps {
    children: React.ReactNode;
    /**
     * List pages: fill the layout's scroll area so the table can own its own
     * scrolling and keep its header and pagination bar pinned (see PageSection).
     */
    fullHeight?: boolean;
    className?: string;
}

/**
 * Outer wrapper for every CRM page.
 *
 * The CRM layout already applies the page padding (`p-4 lg:p-8`), so pages must
 * not add their own `p-6` / `container mx-auto` on top of it — that is what made
 * content width jump from screen to screen.
 */
export const PageContainer: React.FC<PageContainerProps> = ({
    children,
    fullHeight = false,
    className,
}) => (
    <div
        className={cn(
            'flex flex-col gap-6',
            // `min-h-full`, not `h-full`: on a tall viewport the table stretches to
            // fill, and on a short one the page scrolls normally instead of
            // crushing the table to a few pixels under the stats and filter bars.
            fullHeight && 'min-h-full',
            className
        )}
    >
        {children}
    </div>
);

export default PageContainer;
